import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import Logo from '../assets/imgs/hygie.svg';

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true,
            isLogged: this.props.isLogged
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    logOff() {
        this.setState({ isLogged : false });
        localStorage.clear();
        this.props.onLogOff();
    }

    print() {
        window.history.pushState(null, "Print attestation", "/attest");

        setTimeout(() => {
            window.print();
        }, 100)
    }

    render() {
        const { isLogged } = this.props;

        return (
            <header>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light>
                    <Container>
                        <NavbarBrand tag={Link} to="/">
                            <img src={ Logo} alt="logo hygie" width="200" />
                        </NavbarBrand>
                        <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                        <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
                            <ul className="navbar-nav flex-grow">
                                
                                {isLogged &&
                                    <>
                                    <NavItem>
                                        <NavLink tag={Link} className="text-dark" to="/">Accueil</NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink tag={Link} className="text-dark" to="/attest" onClick={() => this.print()}>Imprimer</NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink tag={Link} className="text-dark" to="/" onClick={() => this.logOff()}>Se d&eacute;connecter</NavLink>
                                    </NavItem>
                                    </>
                                }
                               
                            </ul>
                        </Collapse>
                    </Container>
                </Navbar>
            </header>
        );
    }
}
